import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=94b55b1c&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"
import style0 from "./Ratings.vue?vue&type=style&index=0&id=94b55b1c&lang=scss"
import style1 from "./Ratings.vue?vue&type=style&index=1&id=94b55b1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b55b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b55b1c')) {
      api.createRecord('94b55b1c', component.options)
    } else {
      api.reload('94b55b1c', component.options)
    }
    module.hot.accept("./Ratings.vue?vue&type=template&id=94b55b1c&scoped=true", function () {
      api.rerender('94b55b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/Ratings.vue"
export default component.exports